import { ClassValue } from 'clsx';
import { View } from '@shared/components/View';
import { Checkbox } from '@shared/components/checkbox';
import classNames from './EntitySelectionCheckbox.module.css';

interface Props {
  isSelected: boolean;
  className?: ClassValue;
}

export function EntitySelectionCheckbox({ isSelected, className }: Props) {
  return (
    <View className={[classNames.entitySelectionCheckbox, className]}>
      <Checkbox checked={isSelected} />
      <input
        type="checkbox"
        name="entity-selection"
        checked={isSelected}
        readOnly
        data-testid="entity-selection-checkbox"
        tabIndex={-1}
      />
    </View>
  );
}
